<template>
  <div>
    <van-nav-bar title="创建订单"  left-arrow left-text="返回" @click-left="$router.go(-1)" />

    <h2 class="block__title">订单信息</h2>
    <van-form @submit="onSubmit">
        <van-field
            readonly
            clickable
            name="calendar"
            :value="dateValue"
            label="出团日期"
            placeholder="点击选择日期"
            @click="showCalendar = true"
            />
            <van-calendar v-model="showCalendar" @confirm="onDateConfirm" />
            <van-field name="stepper" label="人数" required>
                <template #input>
                    <van-stepper v-model="peoples" />
                </template>
            </van-field>
                <van-field name="stepper2" label="天数" required>
                <template #input>
                    <van-stepper v-model="days" />
                </template>
            </van-field>
            <van-field v-model="address" label="目的地" placeholder="请输入目的地址" required />
            <van-field
                v-model="message"
                rows="2"
                autosize
                label="客人名单"
                type="textarea"
                maxlength="5000"
                placeholder="文本格式的名单可直接复制粘贴于此"
                show-word-limit
                />
            <!-- <van-field label="金额" :value="price" readonly /> -->
            <h2 class="block__title">单笔订单单次最多上传9张图片</h2>
            <van-uploader v-model="fileList" multiple :max-count="9" :after-read="afterRead"  />

            <h2 class="block__title">Word,Excel等格式的电子名单文件,可之间拖拽于此上传</h2>
            <van-uploader v-model="fileList2" multiple :max-count="9" accept="*.*" upload-icon="description"  />

        <div style="margin: 16px;">
            <van-button round block type="info" native-type="submit">提交</van-button>
        </div>
      <van-dialog v-model="show" title="请支付"  confirm-button-text="已支付" @confirm="$router.go(-1)" @cancel="$router.go(-1)" :show-cancel-button="true" cancel-button-text="未支付">
        <div class="qrcode" ref="qrCodeUrl" style="margin:0 auto;width:200px;height:200px"></div>
      </van-dialog>
    </van-form>

  </div>
</template>

<script>
import { Toast } from 'vant'
import { suborder, orderamount } from '@/api/index.js'
import { utilsMixin } from '@/mixin/utils'
import { Dialog } from 'vant'

import jIMGCompress from 'jimgcompress'
import QRCode from 'qrcodejs2'

export default {
  name: 'Index',
  mixins: [utilsMixin],
  data() {
    return {
      dateValue: '',
      peoples: 0,
      days: 0,
      address: '',
      price: '',
      message: '',
      showCalendar: false,
      fileList: [],
      fileList2: [],
      compFile: {},
      show: false
    }
  },
  created() {
      
  },
  methods: {
    getinfo() {
        orderamount({days: this.days, peoples: this.peoples}).then(response => {
            this.price = response.data.amount
        }).catch(() => {
           
        })
    },
    creatQrCode(url) {
      this.show = true
      this.$nextTick(() => {
        new QRCode(this.$refs.qrCodeUrl, {
            text: url,
            width: 200,
            height: 200,
            colorDark: '#000000',
            colorLight: '#ffffff',
            correctLevel: QRCode.CorrectLevel.H
        })
      })
    },
    onSubmit() {
        Dialog.confirm({
            title: '确定提交',
            message: '确定提交订单吗？',
        })
        .then(() => {
            let data = new FormData()
            data.append('ontime', this.dateValue)
            data.append('peoples', this.peoples)
            data.append('days', this.days)
            data.append('address', this.address)
            data.append('message', this.message)
            for(let i = 0; i < this.fileList.length; i++) {
                data.append('file' + i, this.compFile[this.fileList[i].file.name], this.fileList[i].file.name)
            }
            for(let i = 0; i < this.fileList2.length; i++) {
                data.append('doc' + i, this.fileList2[i].file, this.fileList2[i].file.name)
            }
            suborder(data).then(response => {
                if (response.success) {
                  let url = response.data.url
                  if(response.data.qrcode) {
                    this.creatQrCode(url)
                  } else {
                    Dialog.confirm({
                    title: '支付完成',
                    message: '您已完成支付？',
                    confirmButtonText: '已支付',
                    cancelButtonText: '未支付'
                  })
                    .then(() => {
                      Dialog.alert({
                        title: '提示',
                        message: '支付到账会有延迟，请耐心等待',
                      }).then(() => {
                        this.$router.go(-1)
                      });
                    })
                    .catch(() => {
                      // on cancel
                    })
                    location.href = url
                  }
                }
            }).catch((e) => {
                Toast.fail(e)
            })
        })
        .catch(() => {
            // on cancel
        });
        
    },
    onDateConfirm(date) {
      this.dateValue = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`
      this.showCalendar = false
    },
    afterRead(file) {
      const _this = this
      jIMGCompress.compress(file.file, { width: 1000, quality: 0.8 }, (result) => {
          _this.compFile[result.fileName] = result.blob
      }, (error) => {
          Toast.fail(error.msg)
      })
    }
  },
  watch: {
    peoples: function () {
      this.getinfo()
    },
    days: function () {
      this.getinfo()
    }
  }
}
</script>
